import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors } from 'copyright-clearance-center-common-ui';

// We are using custom styles for the dropdown button
// because RUP Styles didn't present its own ones.
const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			padding: '0.75rem',
			width: '100%',
			height: 'auto',
			lineHeight: '1rem',
			justifyContent: 'flex-start',
			// to override RUP btn style
			border: 'none !important',
			'&:active': {
				backgroundColor: Colors.neutral300
			},
			'& svg': {
				width: '1rem',
				height: '1rem',
				marginRight: '0.25rem'
			}
		}
	})
);

export interface IDropdownMenuButtonProps {
	onClick: () => void;
	disabled?: boolean;
	testId?: string;
	controlledBy?: string;
	className?: string;
}

const DropdownMenuButton: React.FunctionComponent<IDropdownMenuButtonProps> = props => {
	const classes = useStyles();
	return (
		<button
			className={clsx(classes.root, 'rup-btn--text rup-btn--neutral', props.className)}
			type="button"
			onClick={props.onClick}
			data-test-id={props.testId ?? 'btn'}
			data-controlled-by={props.controlledBy || 'self'}
			disabled={props.disabled}
		>
			{props.children}
		</button>
	);
};

export default DropdownMenuButton;
